<template>
  <div id="background-edit" :class="currentView">
    <div ref="containerRef" class="rendered-container">
      <Croppie
        ref="croppieRef"
        :image="{ url: background.originalUrl || 'https://via.placeholder.com/100?text=NO+IMAGE' }"
        :resize="false"
        :full="true"
        @crop="cropped"
        @cancel="setOverlay()"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Mixin from './Mixin.js'

export default {
  name: 'BackgroundOverlay',
  mixins: [Mixin],
  data() {
    return {
      html: '',
    }
  },
  computed: {
    ...mapGetters('landing', ['active']),
    ...mapState('landing', ['activeId', 'currentView']),
    background() {
      return this.active.options[this.currentView].background
    },
  },
  methods: {
    cropped(result) {
      this.updateOptions({
        id: this.activeId,
        path: `${this.currentView}.background`,
        value: {
          ...this.background,
          ...result,
        },
      })
      this.setOverlay()
    },
  },
}
</script>

<style lang="scss" scoped>
#background-edit {
  height: 100vh;
  overflow-y: auto;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background-color: white;

  .rendered-container {
    //height: 100%;
    position: relative;
    width: 100%;
    > div {
      /deep/ {
        > div {
          background-image: none;
          width: 100%;
        }
      }
    }
    /deep/ {
      .container {
        min-height: 100px;
      }
    }

    .croppie-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;

      // /deep/ {
      //   .croppie-container {
      //     opacity: 0.6;
      //   }
      // }
    }
  }

  &.sm > .rendered-container {
    width: 375px;
    height: 80vh;
  }
  &.md > .rendered-container {
    width: 600px;
    height: 80vh;
  }
  &.lg > .rendered-container {
    width: 1356px;
    height: 80vh;
  }

  button {
    position: absolute;
    top: 0;
    right: 50%;
  }
}
</style>
